export default class Modal {

    constructor(root) {
        this.container = root;
        this.contentContainer = this.container.querySelector('.content-container');
        this.closeButton = this.contentContainer.querySelector('.close-button');
        this.progressMessage = this.container.querySelector('.progress-spinner .heading');
        this.progressStatus = this.container.querySelector('.progress-spinner .status');

        const _this = this;
        this.container.addEventListener('click', e => {
            if(!_this.isShowingProgress()) {
                if(e.target.isEqualNode(this.container)) {
                    _this.close();
                }
            }
        });

        this.closeButton.addEventListener('click', () => {
            if(!_this.isShowingProgress()) {
                _this.close();
            }
        });
    }

    addEventListener(event, callback) {
        this.container.addEventListener(event, callback);
    }

    isShowingProgress() {
        return this.container.classList.contains('show-progress');
    }

    toggleProgress(isVisible, message = '', status = '') {
        if(isVisible) {
            this.progressMessage.innerHTML = message;
            this.progressStatus.innerText = status;
            this.container.classList.add('show-progress');
        } else {
            this.progressMessage.innerHTML = '';
            this.progressStatus.innerText = '';
            this.container.classList.remove('show-progress');
        }
    }

    setStatus(status) {
        this.progressStatus.innerText = status;
    }

    open() {
        this.container.classList.add('open');
        document.body.classList.add('prevent-scroll');
    }

    close() {
        this.container.classList.remove('open');
        document.body.classList.remove('prevent-scroll');
    }
}